import { Category } from "@mui/icons-material";
import { ProductionQuantityLimits } from "@mui/icons-material";
import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  const { name, image, cost, rating, _id } = product;
  return (
    <Card className="card">
      <div className="imgContainer"> 
      <CardMedia component="img" alt={name} image={image} />
       </div>
      <CardContent>
        <Typography variant="h5"  fontSize={15}>
          {name}
        </Typography>

        <Typography  fontWeight="700">
          ${cost}
        </Typography>

        <div className="ratingDiv">
          <Rating name="read-only" value={rating} precision={0.5} readOnly   />
          </div>
        <Button
          className="card-button"
          width={100}
          fullWidth
          variant="contained"
          startIcon={<AddShoppingCartOutlined />}
          onClick = {()=>handleAddToCart({productId:_id, qty:1}, true)}
        > 
          ADD TO CART
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
